import { useAuth } from '@clerk/clerk-react';
import useSWR from 'swr';
import { spacesApi } from '@/lib/api';
import { VOLATILE_SWR_OPTIONS, useAuthedFetcher } from './swrConfig';

// `period` is a yyyy-MM key for a monthly space and 'trip' for a trip, whose one budget period is the whole trip.
export function useSpaceBudget(spaceId: string, period: string) {
  const { userId } = useAuth();
  const fetch = useAuthedFetcher();
  return useSWR(userId ? ['space-budget', userId, spaceId, period] : null,
    () => fetch((token) => spacesApi.budget(token, spaceId, period)),
    { ...VOLATILE_SWR_OPTIONS, shouldRetryOnError: false });
}
